import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManualRecordedDataTableComponent } from './components/manual-recorded-data-table/manual-recorded-data-table.component';
import { MeasurementFillerComponent } from './components/measurement-filler/measurement-filler.component';
import { MatTableModule } from '@angular/material';
import { TranslateModule } from '../../../../shared/translate/translate.module';
import { ModalsModule } from '../../../../widgets/entry-components/modal/modals.module';

@NgModule({
  declarations: [ManualRecordedDataTableComponent, MeasurementFillerComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    ModalsModule
  ],
  exports: [ManualRecordedDataTableComponent, MeasurementFillerComponent]
})
export class ObservationManualAddModule { }
